<template>
  <v-card flat class="v2-card">
    <v-card-text>
      <v-layout row wrap align-center>
        <v-flex xs12 sm6 md3>
          <v-text-field v-model="tableData.search" @input="getData" label="Search" prepend-inner-icon="search" outline hide-details></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-select :items="statuses" v-model="tableData.filter.syndication_status" @change="getData" label="Select Status" item-text="syndication_status" item-value="syndication_status" single-line outline dense hide-details></v-select>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs12 md2 class="text-xs-right">
          <v-btn color="primary" depressed class="ma-0" :block="$vuetify.breakpoint.xsOnly" :loading="excelBtnLoader" @click="exportReport">
            <v-icon left small>file_download</v-icon>Export Report
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-progress-linear :indeterminate="processBar" height="3" class="my-0"></v-progress-linear>
    <div class="v2-table-scroll">
      <v-data-table :headers="headers" :items="dealSyndication_payouts" item-key="id" :expand="false" hide-actions disable-initial-sort :pagination.sync="pagination" @update:pagination="onPagination">
        <template slot="items" slot-scope="props">
          <tr class="v2-row" @click="toggleRow(props)">
            <td class="hidden-xs-only">{{ props.item.syndication_agreement_date }}</td>
            <td><v-chip small outline :color="statusColor(props.item.syndication_status)">{{ props.item.syndication_status }}</v-chip></td>
            <td class="hidden-xs-only">{{ props.item.contract_MID }}</td>
            <td>{{ props.item.syndication_company_name }}</td>
            <td class="hidden-xs-only">{{ props.item.syndication_total_participation_amt | currency }}</td>
            <td class="hidden-xs-only">{{ props.item.syndication_part_rtr | currency }}</td>
            <td class="hidden-xs-only">{{ upto2decimal(props.item.anticipatedPercent) }}%</td>
            <td>
              <template v-if="isExcludedBalance(props.item.syndication_status)">$0.00</template>
              <template v-else>{{ props.item.syndication_balance | currency }}</template>
            </td>
            <td>{{ props.item.totalPayouts | currency }}</td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
          <DealExpand :payouts="deal_payouts" :contract_MID="props.item.contract_MID" />
        </template>
      </v-data-table>
    </div>
    <div class="text-xs-center py-2">
      <v-pagination v-model="tableData.page" :length="pages" :total-visible="$vuetify.breakpoint.xsOnly ? 3 : 7" @input="next"></v-pagination>
    </div>
  </v-card>
</template>

<script>
import dealsTable from '../../mixins/dealsTable'
import DealExpand from './DealExpand.vue'

export default {
  mixins: [dealsTable],
  components: { DealExpand },
  data: () => ({
    exportType: 'quickview',
    sortValueFallback: 'deal_syndications.syndication_agreement_date',
    headers: [
      { text: 'Agreement Date', value: 'syndication_agreement_date', class: 'hidden-xs-only' },
      { text: 'Status', value: 'syndication_status' },
      { text: 'MID', value: 'mid', class: 'hidden-xs-only' },
      { text: 'Merchant', value: 'merchant' },
      { text: 'Total Investment Cost', value: 'syndication_total_participation_amt', class: 'hidden-xs-only' },
      { text: 'Anticipated return', value: 'syndication_part_rtr', class: 'hidden-xs-only' },
      { text: 'Anticipated return %', value: 'anticipatedPercent', class: 'hidden-xs-only' },
      { text: 'Balance', value: 'syndication_balance' },
      { text: 'Total Payouts', value: 'totalPayouts' },
    ],
  }),
  methods: {
    exportFileName: () => 'quickview.xlsx',
  },
}
</script>
